module.exports = __webpack_public_path__ + "img/gala_add.0777e873.svg";